import Asset from '../../../models/Asset';

Vue.component('asset-update-online-price', {
    props: ['asset'],
    //language=HTML
    template: `
        <div :class="{'input-group': currentAsset.isSimple}" :key="loadComponent">
            <template v-if="currentAsset.isSimple">
                <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                </div>
                <input type="number" class="form-control table-input" name="online_price" v-model="currentAsset.online_price" @change="updateModel" :disabled="currentAsset.busy">
                <small class="help-block invalid-feedback" v-show="currentAsset.errors.has('online_price')">
                    {{ currentAsset.errors.get('online_price') }}
                </small>
            </template>
            <template v-else>
                {{ currentAsset.online_price | money }}
            </template>
        </div>
    `,
    data() {
        return {
            currentAsset: null,
        };
    },
    methods: {
        updateModel() {
            const _this = this;
            this.currentAsset.update(['online_price']).then(() => {
                _this.currentAsset.refresh();
            });
        },
    },
    watch: {
        asset: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.currentAsset = new Asset(newVal);
                this.reloadComponent();
            },
        },
    },
});
